<script setup>
import TitleComponent from '@/components/TitleComponent/index.vue'
import { getCategoryFilterAPI, getCategoryListAPI,getProductListAPI } from '@/apis/category'
import {getTotalSalesTopAPI } from '@/apis/home'
import { compile, onMounted, ref } from 'vue'
import { useMeta } from 'vue-meta';
import { useRoute } from 'vue-router'
import { useHead } from '@vueuse/head';
import GoodsItem from '../Home/components/GoodsItem.vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n();
// 获取面包屑导航数据
const categoryData = ref({})
const route = useRoute()
/**
 * 获取商品分类
 */
// const getCategoryData = async () => {
//     const res = await getCategoryFilterAPI()
//     console.log('=====分类', res.data.categoryList,route.query)
//     if (res.data.categoryList) {
//         categoryData.value = res.data.categoryList.find(item => item.id === 1);
//         console.log('分类', categoryData.value)
//     }
// }
// 获取基础列表数据渲染
const goodList = ref([])
const reqData = ref({
    name: null,
    categoryId: null,
    page: 1,
    pageSize: 10,
})
const status = ref()
const zhi = computed(() => route.params.id);
console.log(zhi)
onMounted(() => {
    useMeta({
        title: t('setup505'),
        meta: [
          { name: 'keywords', content: t('setup505') },
          { name: 'description', content: t('setup506') }
        ]
      });
      if (route.params.type == 2) {
        reqData.value.name = route.params.id
    } else if (route.params.type == 4) {
        reqData.value.categoryId = null
    } else {
        reqData.value.categoryId = route.params.id
        // getCategoryData();
    }
    getGoodList();
})

onUpdated(()=>{
    useHead({
            title: t('setup505')+' - '+reqData.value.name,
            meta: [
                { name: 'description', content: reqData.value.name}
            ]
        });
})
const total = ref()
const isData=ref(false)
/**
 * 获取商品列表
 */
const getGoodList = async () => {
    try {
        if(route.params.type == 4){//热卖中
            const res = await getTotalSalesTopAPI(reqData.value)
            if (res.code == 0) {
                loading.value = false
                goodList.value = res.data.data
                total.value = res.data.total
                if(total.value == 0){
                    isData.value=true
                }else{
                    isData.value=false
                }
            }
        }else{
            const res = await getProductListAPI(reqData.value)
            if (res.code == 0) {
                loading.value = false
                goodList.value = res.data.data
                total.value = res.data.total
                if(total.value == 0){
                    isData.value=true
                }else{
                    isData.value=false
                }
            }
        }
        
    } catch (error) {
        console.log('err')
        loading.value = false
        goodList.value = []
            total.value = 0
    }
   

}

const loading = ref(false)
// const noMore = computed(() => goodList.value.length >= total.value)
const noMore = computed(() => {
    if(goodList.value){
        
       if(goodList.value.length >= total.value) {
        
        return true;
       }else{
        return false;
       }
    }
}
)
const disabled = computed(() => loading.value || noMore.value)
const load = async() => {
    if( total.value>goodList.value?.length){

  
    loading.value = true
    // setTimeout(async () => {
        reqData.value.page++
        const res = await getProductListAPI(reqData.value)
        if (res.data.data) {
            goodList.value = [...goodList.value, ...res.data.data]
            loading.value = false
        }
    // }, 3000)
    }
}





</script>

<template>
    <div class="container ">

        <!-- 面包屑 -->
        <div class="bread-container">
            <el-breadcrumb separator=">">
                <el-breadcrumb-item :to="{ path: '/' }">{{ $t('home43') }}</el-breadcrumb-item>
                <el-breadcrumb-item v-if="route.params.type == 2">{{
                    reqData.name }}
                </el-breadcrumb-item>
                <el-breadcrumb-item v-else-if="route.params.type == 3" :to="{ path: `/category/${categoryData.id}` }"> {{ route.query.fname }} > {{ route.query.name }}
                </el-breadcrumb-item>
                <el-breadcrumb-item v-else-if="route.params.type == 4">  {{$t('setup438') }}
                </el-breadcrumb-item>
                <el-breadcrumb-item v-else :to="{ path: `/category/${categoryData.id}` }">{{ categoryData.name }}>{{ route.query.name }}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="sub-container" v-if="isData==false">
            <TitleComponent v-if="isMobile == true"></TitleComponent>

            <div class="body" v-infinite-scroll="load" :infinite-scroll-disabled="disabled">
                <!-- 商品列表-->
                <GoodsItem v-for="goods in goodList" :goods="goods" :key="goods.id" />
            </div>
            <p v-if="loading" style="text-align: center;">Loading...</p>
            <p v-if="noMore" style="text-align: center;">No more</p>
        </div>
        <div v-else style="height: 400px;display: flex;align-items: center;justify-content: center;width: 100%; ">
           <div>{{ $t('setup11') }}</div> 
        </div>
    </div>
</template>



<style lang="scss" scoped>
.bread-container {
    padding: 25px 0;
    color: #666;
}

.sub-container {
    padding: 20px 10px;
    background-color: #fff;

    .body {
        display: grid;
                grid-template-columns: repeat(auto-fit, minmax(220px, 0fr));
                grid-auto-rows: 429px;
                grid-gap: 20px;
    }
    .pagination-container {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }


}

@media (max-width: 768px) {
    .container {
        width: 100%;
        padding-top: 83px;
    }

    .bread-container {
        width: 100%;
        z-index: 985;
        position: fixed;
        top: 60px;
        padding: 10px 10px;
        color: #666;
        background-color: #f3f3f3;
    }

    .sub-container {
        .body {
            // display: flex;
            // flex-wrap: wrap;
            // justify-content: space-between;
            // gap: 5px;
            // width: 100%;
            // height: 100%;
                
                    display: grid;
                    grid-template-columns: repeat(auto-fit, minmax(48%, 0fr));
                    grid-auto-rows: 320px;
                    grid-gap: 10px;
               
        }
    }
}
</style>